// THE WORKSPACE APPS VIEW (/apps) — docs/APP_SPLIT.md §5.2,
// WS-STUDIO-SPLIT-WORKSPACE-APPS-FROM-SITES. Nika 2026-10-19: "workspace apps
// are pure adons on workspace and websites made on it are deployed and
// published". The Apps hub has two views (CanvasViewNav VIEW_NAV): this one
// holds the add-ons of the workspace — installed, built by the team, offered
// by the App Store. Websites live on the /studio board, never here.
//
// Rows come from `appsHubModel` (functions/appsHub.js): each row carries every
// key it reads and an `app-…` key, so no row falls back to the root state and
// no data key names an HTML tag.

// The page body: lede, the three sections, the empty state, the way to the
// Websites view.
export const AppsHubMain = {
  flow: 'y',
  gap: 'B',
  padding: 'A',
  minWidth: '0',
  overflow: 'auto',
  onRender: (el) => {
    if (el.__appsHubLoaded) return
    el.__appsHubLoaded = true
    el.call('appsHubLoad')
  },

  // THE ONE CATALOGUE's row (Nika's decision 7, "one catalogue": /apps + an
  // App Store tab; persona audit round 1, ledger AS-3): this page is its
  // "Workspace apps" tab, /apps/store its App Store tab — the store draws the
  // same row, so the two read as one place.
  AppsCatalogueTabs: { current: 'apps' },

  AhLede: {
    tag: 'p',
    margin: '0',
    color: 'caption',
    fontSize: 'Z2',
    text: '{{ workspace.appsHub.lede | polyglot }}'
  },

  AppsHubSection_installed: { sectionKey: 'installed' },
  AppsHubSection_team: { sectionKey: 'team' },
  AppsHubSection_store: { sectionKey: 'store' },

  AhEmpty: {
    flow: 'y',
    align: 'flex-start',
    gap: 'Z',
    hideDeps: [
      'workspaceApps',
      'workspaceProject',
      'workspace',
      '_userApps',
      '_wsAppsCatalog',
      '_projectsForActiveOrg',
      '_workspacePresets'
    ],
    hide: (el, s) => {
      const m = el.call('appsHubModel', s.root)
      return m.installed.length + m.team.length > 0
    },
    AhEmptyTitle: {
      tag: 'h2',
      margin: '0',
      fontSize: 'A',
      fontWeight: '700',
      color: 'title',
      text: '{{ workspace.appsHub.empty.title | polyglot }}'
    },
    AhEmptyBody: {
      tag: 'p',
      margin: '0',
      color: 'caption',
      fontSize: 'Z2',
      text: '{{ workspace.appsHub.empty.body | polyglot }}'
    }
  },

  AhToWebsites: {
    extends: 'Link',
    href: '/studio',
    alignSelf: 'flex-start',
    fontSize: 'Z2',
    color: 'caption',
    textDecoration: 'underline',
    ':hover': { color: 'title' },
    ':active': { color: 'title' },
    text: '{{ workspace.appsHub.toWebsites | polyglot }}',
    onClick: (e, el) => {
      e.preventDefault()
      el.call('openAppPage', '/studio')
    }
  }
}
